import { Swiper } from 'swiper';
import { Pagination, Navigation } from 'swiper';
const HeroCarousel = () => {
  const sections = document.querySelectorAll('.media-carousel');

  Swiper.use([Pagination, Navigation]);

  sections.forEach(function (section) {
    const id = section.getAttribute('id');
    const prevEl = section.querySelector( '.swiper-button-prev' );
    const nextEl = section.querySelector( '.swiper-button-next' );
    const paginationEl = section.querySelector('.swiper-pagination');
    let swiperParms = {
      slidesPerView: 1,
      keyboard: true,
      spaceBetween: 40,
      navigation: {
        nextEl,
        prevEl
      },
      pagination : {
        el: paginationEl,
        clickable: true
      },
      breakpoints: {
        576: {
          slidesPerView: 1.1,
          spaceBetween: 24
        },
      },
      on: {
        slideChange: (swiper) => {
          setTimeout(() => {
            swiper.slides.forEach((slide) => {
              const video = slide.querySelector('video');
              if (video) {
                if (slide.classList.contains('swiper-slide-active')) {
                  video.play();
                } else {
                  video.pause();
                }
              }
            })
          }, 0)
        }
      }
    };
    const swiper = new Swiper(`#${id} .swiper`, swiperParms);

  });
};

export default HeroCarousel;
